<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-file-cog-outline" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Arquivos Tratados</div>
      </template>
      <v-btn
        id="btn-nova-perdas-aic"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push({ name: 'Envio de Arquivos de Dados' })"
      >
        <v-icon left size="30px">mdi-arrow-left-bold</v-icon>
        Voltar
      </v-btn>
      <v-text-field
        id="perdas-aic-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Arquivo" />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        :loading="loading"
        no-data-text="Nenhum arquivo disponível"
        no-results-text="Nenhum registro correspondente encontrado"
      >
        <template v-slot:[`item.arquivo_original`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.arquivo_original }}
              </div>
            </template>
            <span>{{ item.arquivo_original }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-perdas-aic"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            :disabled="item.status != 'SUCESSO'"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="((dialogCreationLog = true), (dialogCreationLogData = { username: item.usuario, created: item.created }))"
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar os arquivos</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
  </v-container>
</template>

<script>
  import ArquivosDadosService from '@/services/ArquivosDadosService';

  export default {
    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue')
    },

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    emits: ['rechargeTable'],

    data: () => ({
      powerupService: ArquivosDadosService,
      powerupEntityName: 'Tratativa de Arquivos',
      downloadProgressData: {},
      search: '',
      dialogCreationLog: false,
      dialogCreationLogData: {},
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Arquivo',
          value: 'arquivo_original'
        },
        {
          text: 'Ano',
          value: 'ano'
        },
        {
          text: 'Mês',
          value: 'mes'
        },
        {
          text: 'Tratativa',
          value: 'tratativa'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    methods: {
      downloadItem(item) {
        if (this.downloadProgressData[item.id] !== undefined) return;

        const id = item.arquivo_tratado_id;

        this.$set(this.downloadProgressData, item.id, { id });
        this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 2000 });

        ArquivosDadosService.download(id, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;
            this.$set(this.downloadProgressData, item.id, { progress, isComputable, id });
          }
        })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.arquivo_tratado + '.zip');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error(`Erro ao baixar arquivo '${item.arquivo_tratado}'.`, '', { position: 'topRight' });
          })
          .finally(() => {
            this.$delete(this.downloadProgressData, item.id);
          });
      }
    }
  };
</script>
